import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction, handleActions } from 'redux-actions';
import { PATH_DELIMITER, SYSTEM_TERM_PATH } from '../../../constant/Constant';
import NullCheckUtil from '../../../util/NullCheckUtil';
import { request } from '../../ApiModule';
import { SET_GRID_DATA } from '../../component/TableBoxModule';

const INIT = SYSTEM_TERM_PATH + PATH_DELIMITER + 'INIT';
const ACTION_SEARCH = SYSTEM_TERM_PATH + PATH_DELIMITER + 'ACTION_SEARCH';
const HANDLE_SEMESTER_NM = SYSTEM_TERM_PATH + PATH_DELIMITER + 'HANDLE_SEMESTER_NM';

export const actionInit = createAction(INIT);
export const actionSearch = createAction(ACTION_SEARCH);
export const handleSemesterNm = createAction(HANDLE_SEMESTER_NM);

export function* subjectSearchSagas() {
    yield takeEvery(ACTION_SEARCH, actionSearchSaga);
}

function* actionSearchSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'get',
        url: '/api/course',
        params,
        callback,
    });
    if (NullCheckUtil.isNotNull(result)) {
        yield put({
            type: SET_GRID_DATA,
            payload: {
                ...result,
                rows: result.rows.map((row) => ({ ...row.courseInfo, courseTimes: row.courseTimes })),
            },
        });
    }
}

const initialState = {
    semesterNm: null,
};

const module = handleActions(
    {
        [INIT]: () => initialState,
        [HANDLE_SEMESTER_NM]: (state, { payload: semesterNm }) => ({ ...state, semesterNm }),
    },
    initialState,
);

export default module;
